import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Task } from "../_types/task";
import { TaskComment } from "../_types/task-comment";

@Injectable({
    providedIn: 'root',
})
export class TasksCommentsService extends Service<TaskComment> {
    public override type = 'taskComments';
    public override url = 'attendance/taskComments';
}
